import { useEffect, useState } from 'react';

import { useSearchApi } from '../../../api/SearchApiProvider';

type TMatchData = {
  face_id?: string | null;
  event_id?: string | null;
} | null | undefined;

function useReferenceMatchData(
  matchData: TMatchData,
): [Record<string, unknown> | undefined, 'face' | 'event'] {
  const api = useSearchApi();
  const type = matchData?.face_id ? 'face' : 'event';
  const dataId = matchData?.face_id ?? matchData?.event_id;

  const [match, setMatch] = useState<Record<string, unknown>>();

  useEffect(() => {
    if (!dataId) {
      setMatch(undefined);
      return undefined;
    }

    let cancelled = false;
    api.getReferenceInfo({ id: dataId, type })
      .then(async (info) => {
        const matchInfo = info?.[0] as unknown as Record<string, unknown> | undefined;
        if (matchInfo && Array.isArray(matchInfo.lists) && typeof matchInfo.lists[0] === 'string') {
          const listOptions = await api.getListOptions();
          matchInfo.lists = (matchInfo.lists as string[]).map((listId) => {
            const option = listOptions.find((item) => item.value === listId);
            return { list_id: listId, user_data: option?.label ?? listId };
          });
        }
        if (!cancelled) setMatch(matchInfo);
      })
      .catch(() => {
        if (!cancelled) setMatch(undefined);
      });

    return () => {
      cancelled = true;
    };
  }, [api, dataId, type]);

  return [match, type];
}

export { useReferenceMatchData };
